import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import styled from '@emotion/styled';
import { SingleArticleBody } from 'data/SingleArticle/types';
import {
  baseMarksElementsConfiguration,
  renderNodeWithEmbedConfiguration,
} from './configuration';

const Outer = styled.article`
  > * {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  > H2 {
    margin-top: 60px;
  }
  > H3 {
    margin-top: 40px;
  }
`;

type Props = {
  body: SingleArticleBody;
};

export const RichText = ({ body }: Props) => {
  const formattedText = documentToReactComponents(body.json, {
    renderNode: renderNodeWithEmbedConfiguration({
      blockEmbeds: body.links.entries.block,
      inlineEmbeds: body.links.entries.inline,
    }),
    renderMark: baseMarksElementsConfiguration,
  });

  return <Outer>{formattedText}</Outer>;
};
